var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h2>Average Daily Vault Balance Page</h2>\n</div>\n";
var id1="average_daily_vault_balance.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/components/branch_management/components/average-daily-vault-balance/average_daily_vault_balance.html
// module id = 2663
// module chunks = 1